import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import {
  TEXT_PAGE_ADD_PATH,
  TEXT_PAGE_PATH,
  TEXT_PAGE_UPDATE_PATH,
} from "utils/constants/paths";

const TextPages = Loadable(React.lazy(() => import("./View")));
const TextPagesAddOrUpdate = Loadable(
  React.lazy(() => import("./View/AddOrUpdate"))
);

export const TextPageRoute: IRouteItem = {
  path: TEXT_PAGE_PATH,
  iconName: "DocumentText1",
  element: React.createElement(TextPages),
  name: "Text Pages",
  accessKeys: ["ContentCreator"],
  children: [
    {
      name: "Add / Update",
      path: TEXT_PAGE_ADD_PATH,
      element: React.createElement(TextPagesAddOrUpdate),
      showInDrawer: false,
    },
    {
      path: TEXT_PAGE_UPDATE_PATH,
      element: React.createElement(TextPagesAddOrUpdate),
      showInDrawer: false,
    },
  ],
};
